import { configuredYoutubeVideo } from "../app/media";
import { createYoutubeBackdrop } from "./youtube-player";

export function initVideoHero(config) {
  const section = document.querySelector("[data-video-hero]");
  const title = section?.querySelector("[data-video-hero-title]");
  const backdropContainer = section?.querySelector("[data-video-hero-player]");

  if (
    !section
    || section.hidden
    || !title
    || !backdropContainer
    || !configuredYoutubeVideo(config)
  ) return null;

  title.textContent = config.title;
  const backdrop = createYoutubeBackdrop(config);
  backdropContainer.replaceChildren(backdrop);
  return { backdrop };
}
